import { AutoMap } from "@automapper/classes";

export class PermissionsDTO {
    @AutoMap()
    name!: string;
}  